<template>
  <div>
    <el-form ref="regForm"
             :model="regForm"
             :rules="fieldRules"
             label-position="left"
             label-width="0px"
             class="demo-ruleForm"
    >
      <span class="tool-bar">
        <!-- 主题切换 -->
        <theme-picker style="float:right;"
                      class="theme-picker"
                      :default="themeColor"
                      @onThemeChange="onThemeChange"
        />
      </span>
      <h2 class="title"
          style="padding-left:22px;"
      >
        {{ appName }}
      </h2>
      <el-form-item prop="registerPhone">
        <el-input ref="account"
                  v-model="regForm.registerPhone"
                  type="text"
                  auto-complete="off"
                  placeholder="请输入您的手机号"
                  @keyup.enter.native="accountEnter"
        />
      </el-form-item>
      <el-form-item prop="">
        <el-input v-model="regForm.yzm"
                  placeholder="请输入验证码"
        >
          <el-button slot="append"
                     @click="checkPhone"
          >
            {{ content }}{{ time }}
          </el-button>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input ref="password"
                  v-model="regForm.password"
                  type="password"
                  auto-complete="off"
                  placeholder="请输入您的密码"
                  @keyup.enter.native="passwordEnter"
        />
      </el-form-item>
      <el-form-item prop="password">
        <el-input ref="rePassword"
                  v-model="regForm.rePassword"
                  type="password"
                  auto-complete="off"
                  placeholder="请重复您的密码"
                  @keyup.enter.native="login"
        />
      </el-form-item>
      <el-form-item prop="aggree">
        <el-checkbox v-model="regForm.aggree">
          我同意
        </el-checkbox>
        <span :class="{'fontcolor':regForm.aggree}"
              style="cursor: pointer;"
              @click="dialogVisible = true"
        >《维旺迪服务协议》</span>
        <span :class="{'fontcolor':regForm.aggree}"
              style="cursor: pointer;"
              @click="dialogVisible2 = true"
        >《维旺迪隐私政策》</span>
      </el-form-item>
      <el-form-item style="width:100%;">
        <el-button type="primary"
                   style="width:48%;"
                   :loading="loading"
                   @click.native.prevent="login"
        >
          同意条款并注册
        </el-button>
        <el-button @click="gotoMare">
          返回
        </el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-dialog
        title=""
        top="8vh"
        :visible.sync="dialogVisible"
        width="70%"
      >
        <dynamic-link style="height: 100%;"
                      type="serviceAgreement"
                      componentname="serviceAgreement"
        ></dynamic-link>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        title=""
        top="8vh"
        :visible.sync="dialogVisible2"
        width="70%"
      >
        <dynamic-link style="height: 100%;"
                      type="privacyPolicyab"
                      componentname="privacyPolicyab"
        ></dynamic-link>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ThemePicker from "@/components/ThemePicker";
export default {
  name: "PasswordRegistration",
  components: {
    ThemePicker
  },
  props: {
    closeEvent: {
      type: Function,
      default: () => {
        return Promise.resolve();
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      state: false,
      content: "获取验证码",
      time: "",
      loading: false,
      regForm: {
        registerPhone: "",
        yzm: "",
        password: "",
        rePassword: "",
        aggree: false
      },
      appName: "注册商户账号",
      fieldRules: {
        registerPhone: [{ required: true, message: "请输入手机号", trigger: "blur" }, { min: 11, max: 11, message: "请输入正确的手机号", trigger: "blur" }],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: true
    };
  },
  computed: {
    ...mapState({
      themeColor: state => state.app.themeColor
    })
  },
  mounted() {
    // this.$refs.account.focus();
  },
  methods: {
    gotoMare() {
      this.closeEvent();
    },
    checkPhone() {
      this.$message.info("接口待完善");
      return;
      const then = this;
      const phone = then.regForm.registerPhone;
      if (phone === "") {
        return;
      }
      const token = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInBvc3RJZCI6MSwiZXhwIjo0NjExNjg3NjA0ODM4MDk3LCJjcmVhdGVkIjoxNTg2NDEwNzA1ODMwLCJhdXRob3JpdGllcyI6W119.RBdNZUn7Eiu6l_7Rmm_CU7iaD7pIEYK9FgxxzAQ_iKDNk8gCxSf3MwAkSIGZS256q5vl3PqmDrWxh_SaPLulfQ";
      then.axios({
        hostUrl: then.zuul,
        url: "/xyj-about-cool/aboutCoolStadium/findByRegisterPhone?registerPhone=" + phone,
        method: "post",
        headers: {
          "token": token
        }
      }).then(res => {
        this.getCode();
      }).catch(err => {
        then.$message.error(err.message);
      });
    },
    getCode() {
      const then = this;
      if (then.state) {
        return;
      }
      const phone = then.regForm.registerPhone;
      if (phone === "") {
        return;
      }
      then.state = true;
      then.$tu.startTime(
        () => {},
        (n, times) => {
          then.time = "(" + n + ")";
        },
        () => {
          then.content = "重新获取";
          then.time = "";
        },
        60
      );
      const type = 1;
      const yzmSum = 4;
      const projectCode = "aboutCool";
      const token = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6NDYxMTY4NzU3MDcxMDU3NiwiY3JlYXRlZCI6MTU1MjI4MzE4ODExOSwiYXV0aG9yaXRpZXMiOlt7ImF1dGhvcml0eSI6InN5czp1c2VyOnZpZXcifSx7ImF1dGhvcml0eSI6InN5czptZW51OmRlbGV0ZSJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRlcHQ6ZWRpdCJ9LHsiYXV0aG9yaXR5IjoiZGljdDpjb21wYW55OmFkZCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6ZGVsZXRlIn0seyJhdXRob3JpdHkiOiJzeXM6bWVudTphZGQifSx7ImF1dGhvcml0eSI6InN5czp1c2VyOmFkZCJ9LHsiYXV0aG9yaXR5IjoiZGljdDpjb21wYW55OnZpZXcifSx7ImF1dGhvcml0eSI6InN5czpsb2c6dmlldyJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRlcHQ6ZGVsZXRlIn0seyJhdXRob3JpdHkiOiJzeXM6cm9sZTplZGl0In0seyJhdXRob3JpdHkiOiJzeXM6cm9sZTp2aWV3In0seyJhdXRob3JpdHkiOiJkaWN0OmNvbXBhbnk6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6dmlldyJ9LHsiYXV0aG9yaXR5Ijoic3lzOnVzZXI6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOnVzZXI6ZGVsZXRlIn0seyJhdXRob3JpdHkiOiJzeXM6ZGVwdDp2aWV3In0seyJhdXRob3JpdHkiOiJzeXM6ZGVwdDphZGQifSx7ImF1dGhvcml0eSI6InN5czpyb2xlOmRlbGV0ZSJ9LHsiYXV0aG9yaXR5Ijoic3lzOm1lbnU6dmlldyJ9LHsiYXV0aG9yaXR5Ijoic3lzOm1lbnU6ZWRpdCJ9LHsiYXV0aG9yaXR5Ijoic3lzOmRpY3Q6YWRkIn0seyJhdXRob3JpdHkiOiJzeXM6cm9sZTphZGQifV19.zqeykmLqQRADkfKhQSqltd_q0llDoRfNH4FUYwcdFkWk5KbuWT9e90wZQjYMZldBDtC_XtzyvPHbsHpPJfQHSg";
      then.axios({
        hostUrl: then.zuul,
        url: "/xyj-about-cool/aboutCoolUserMsg/getVerificationCode/" + phone + "/" + type + "/" + projectCode + "/" + yzmSum,
        method: "get",
        headers: {
          "token": token
        }
      })
        .then(res => {})
        .catch(err => {
          then.$message.error(err.message);
        })
        .finally(fn => {
          setTimeout(() => {
            then.state = false;
          }, 60000);
        });
    },
    /**
		 *描述：当输入账号回车时光标移动到密码位置
		 */
    accountEnter() {
      if (this.regForm.registerPhone.length > 0) {
        this.$refs.password.focus();
      }
    },
    // 输入密码回车
    passwordEnter() {
      if (this.regForm.password.length > 0) {
        this.$refs.rePassword.focus();
      }
    },
    // 重复输入密码回车，或者点击同意按钮
    login() {
      this.closeEvent();
      return;
      if (!this.regForm.aggree) {
        this.$message.error("请勾选服务协议及隐私政策");
        return;
      }
      this.$refs.regForm.validate(valid => {
        if (valid) {
          // 验证两次密码是否输入一致
          const then = this;
          if (then.regForm.password !== then.regForm.rePassword) {
            then.$message.error("两次密码输入不一致");
            return;
          } else {
            then.axios({
              hostUrl: then.zuul,
              url: "/xyj-about-cool/aboutCoolStadium/stadiumRegisterByPassword",
              method: "post",
              data: {
                registerPhone: then.regForm.registerPhone,
                password: then.regForm.password,
                yzm: then.regForm.yzm
              }
            })
              .then(res => {
                then.$message.success("注册成功");
                this.$router.go(-1);
              })
              .catch(err => {
                then.$message.error(err.message);
              });
          }
        }
      });
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit("setThemeColor", themeColor);
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
	-webkit-border-radius: 5px;
	border-radius: 5px;
	-moz-border-radius: 5px;
	background-clip: padding-box;
	margin: 100px auto;
	width: 350px;
	padding: 35px 35px 15px 35px;
	background: #fff;
	border: 1px solid #eaeaea;
	box-shadow: 0 0 25px #cac6c6;
	.title {
		margin: 0px auto 30px auto;
		text-align: center;
		color: #505458;
	}
	.remember {
		margin: 0px 0px 35px 0px;
	}
}
.el-checkbox{
	margin-right: 0 !important;
}
.fontcolor{
	color: #00A29D !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PasswordRegistration.vue